<template>
   <v-content>
        <Header></Header>

        <v-layout justify-center align-center
                  style="position: relative;height: 60%"
                  :style="{ 'background': `url(${require('../assets/portfolio-bg.png')}) no-repeat`,
                  'background-size': 'cover' }"
        >
            <div class="gray-layer"></div>
            <v-flex xs11 sm10 md6>

                <v-card elevation="8" class="overflow-hidden">
                    <v-layout>
                        <v-flex py-7 px-5 px-md-10>
                            <v-layout justify-space-between mb-3>
                                <v-flex>
                                    <div class="txt-large">
                                        {{$t('change-password')}}
                                    </div>
                                </v-flex>
                                <v-flex text-end>
                                    <img :src="require('../assets/tcdc-color.png')">
                                </v-flex>
                            </v-layout>

                            <!-- change password -->
                            <div>
                                <span class="font-weight-bold">{{$t('new-password')}}</span>
                                <v-text-field dense solo flat type="password" v-model="new_password" class="mt-2 radius8"></v-text-field>
                                <span class="font-weight-bold">{{$t('confirm-password')}}</span>
                                <v-text-field dense solo flat type="password" v-model="confirm_password" class="mt-2 radius8"></v-text-field>

                                <v-btn class="my-5"
                                       block depressed dark
                                       color="#FD5246"
                                       @click="onChangePass"
                                >
                                    {{$t('change-password')}}
                                </v-btn>
                            </div>

                            <v-btn class="my-5"
                                   block
                                   depressed
                                   outlined
                                   color="#FD5246"
                                   @click="backToLogin">
                                {{$t('back-to-login')}}
                            </v-btn>

                        </v-flex>
                    </v-layout>
                </v-card>

            </v-flex>
        </v-layout>

        <Footer class=""></Footer>

        <loading
                color="#FD5246"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>

    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "ResetPassword",
        components: {
            Header,
            Footer,
            Loading
        },
        data:() => ({
            isLoading: false,
            fullPage: true,
            email: "",
            new_password: "",
            confirm_password: "",
        }),
        methods: {
            backToLogin() {
                this.$router.push('/login');
            },
            onChangePass() {
                if (this.passwordIsCorrect(this.new_password)) {
                    if (this.new_password === this.confirm_password) {
                        let data = {
                            token: this.$route.query.token,
                            password: this.new_password,
                        }
                        this.isLoading = true;
                        this.$store.dispatch('auth/resetPassword', data).then(res => {
                            this.isLoading = false;
                             this.$swal({
                                icon: 'success',
                                text: 'เปลี่ยนรหัสผ่านสำเร็จ',
                                confirmButtonColor: '#FD5246',
                                confirmButtonText: 'ตกลง',
                            })
                        })
                    } else {
                        this.$swal({
                            icon: 'error',
                            text: 'Password not match!',
                            confirmButtonColor: '#FD5246',
                            confirmButtonText: 'ตกลง',
                        }); 
                    }
                } else {
                    this.$swal({
                        icon: 'error',
                        text: 'Password must have 8 letters at least!',
                        confirmButtonColor: '#FD5246',
                        confirmButtonText: 'ตกลง',
                    });
                }
            },
            emailIsCorrect(mail) {
                let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(mail) && mail !== '';
            },
            passwordIsCorrect(pw) {
                return pw.length >= 8;
            }
        }
}
</script>

<style>

</style>